import tw from "twin.macro";
import { Description } from "../SpondGroups/SpondGroups.styles";

const InformationContainer = tw.div`tw-relative tw-w-full tw-bg-gray-100 tw-p-12 tw-mt-12 tw-rounded-xl tw-drop-shadow-2xl tw-border-gray-900 tw-border-2`;

export const AdminInformationContainer = tw(
  InformationContainer,
)`tw-border-solid tw-border-4 tw-border-primary-600`;
export const Attention = tw(
  Description,
)`tw-text-primary-800 tw-font-semibold tw-mt-1 tw-mb-3`;
export const SpondGroupContainer = tw.div`tw-relative tw-mt-2`;
